var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessTrips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,18l-0.5-2.4c-0.3-0.1-0.6-0.3-0.9-0.4c-0.3-0.2-0.6-0.4-0.8-0.6l-2.3,0.8l-1.6-2.8L4.1,11 c0-0.2,0-0.3-0.1-0.5c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0.1-0.5L2.3,7.4l1.6-2.8l2.3,0.8C6.4,5.2,6.7,5,7,4.8 c0.3-0.2,0.6-0.3,0.9-0.4L8.4,2h3.2l0.5,2.4c0.3,0.1,0.6,0.3,0.9,0.4s0.6,0.4,0.8,0.6l2.3-0.8l1.6,2.8l-1.6,1.4 c-0.3-0.1-0.6-0.2-1-0.2c-0.3,0-0.6-0.1-1,0c-0.2,0-0.5,0-0.8,0.1c-0.2,0.1-0.5,0.1-0.7,0.2c-0.2-0.6-0.6-1-1.1-1.3S10.6,7,10,7 C9.2,7,8.5,7.3,7.9,7.9C7.3,8.5,7,9.2,7,10c0,0.7,0.2,1.3,0.6,1.8c0.4,0.5,0.9,0.9,1.6,1.1c0,0.2-0.1,0.4-0.1,0.6c0,0.2,0,0.4,0,0.6 c0,0.8,0.1,1.5,0.4,2.2c0.3,0.7,0.7,1.3,1.3,1.8H8.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,18.3c-0.6,0-1.1-0.1-1.7-0.3c-0.5-0.2-1-0.5-1.4-0.9c-0.4-0.4-0.7-0.8-0.9-1.4c-0.2-0.5-0.3-1.1-0.3-1.7 c0-0.6,0.1-1.1,0.3-1.7c0.2-0.5,0.5-1,0.9-1.4s0.8-0.7,1.4-0.9c0.5-0.2,1.1-0.3,1.7-0.3c0.6,0,1.1,0.1,1.7,0.3 c0.5,0.2,1,0.5,1.4,0.9c0.4,0.4,0.7,0.8,0.9,1.4c0.2,0.5,0.3,1.1,0.3,1.7c0,0.6-0.1,1.1-0.3,1.7s-0.5,1-0.9,1.4 c-0.4,0.4-0.8,0.7-1.4,0.9C15.9,18.2,15.4,18.3,14.8,18.3z M14.8,17.5c0.9,0,1.7-0.3,2.3-0.9s1-1.3,1.1-2.2 c-0.1,0.1-0.1,0.1-0.2,0.1s-0.2,0-0.3,0h-1.6c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.3-0.2-0.6v-0.5h-1.9v-1.1 c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.3-0.2,0.6-0.2h0.5v-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0,0-0.1,0-0.1,0h-0.1 c-1,0-1.8,0.3-2.4,1c-0.7,0.7-1,1.5-1,2.4h2.4c0.4,0,0.8,0.2,1.1,0.5s0.5,0.7,0.5,1.1v0.5h-1.6v1.2c0.2,0.1,0.3,0.1,0.5,0.1 S14.6,17.5,14.8,17.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessTrips);
export default __webpack_public_path__ + "static/media/process-trips.1c4d18cd8eabee127f1de5cc708e63a5.svg";
export { ForwardRef as ReactComponent };